/* Linsoul header + megamenu. Source: Linsoul New Site Updated/assets/site-header.js.
   Panels are rendered by sections/ls-header.liquid; this file only switches, positions and animates them. */
(() => {
  'use strict';

  let teardown = null;

  function init() {
    teardown?.();
    const header = document.getElementById('menu-header');
    if (!header) return;

    const controller = new AbortController();
    const signal = controller.signal;
    const $ = (s, r = document) => r.querySelector(s);
    const $$ = (s, r = document) => [...r.querySelectorAll(s)];
    const surface = $('#menu-surface', header);
    const backdrop = document.getElementById('menu-backdrop');
    const label = $('#mobile-menu-label', header);
    const back = $('.ml-back', header);
    const mobileButton = $('[data-mobile-menu]', header);
    const panels = Object.fromEntries($$('.ml-panel', surface).map((p) => [p.dataset.panel, p]));
    const mobile = matchMedia('(max-width:820px)');
    const reduce = matchMedia('(prefers-reduced-motion:reduce)');

    let active = null;
    let opener = null;
    let animation = null;
    let sequence = 0;
    let oldOverflow = '';

    const currentPanel = () => panels[active || 'root'];

    function tabs(panel = currentPanel()) {
      return panel ? $$('[data-sub]', panel) : [];
    }

    function selectTab(index, focus = false) {
      const panel = currentPanel();
      const buttons = tabs(panel);
      if (!buttons.length) return;
      buttons.forEach((b, i) => {
        const selected = i === index;
        b.setAttribute('aria-selected', String(selected));
        b.tabIndex = selected ? 0 : -1;
        const tabpanel = document.getElementById(b.getAttribute('aria-controls'));
        if (tabpanel) tabpanel.hidden = !selected;
      });
      if (focus) buttons[index].focus({ preventScroll: true });
      position();
    }

    function render() {
      const id = active || 'root';
      Object.entries(panels).forEach(([key, p]) => { p.hidden = key !== id; });
      const panel = currentPanel();
      surface.dataset.layout = active ? panel?.dataset.layout || 'compact' : 'root';
      surface.setAttribute('aria-label', active ? `${panel.dataset.name} navigation` : 'All sections');
      if (label) label.textContent = active ? panel.dataset.name : 'Menu';
      if (back) back.hidden = !active;
      $$('.ml-directory-tabs', surface).forEach((t) => t.setAttribute('aria-orientation', mobile.matches ? 'horizontal' : 'vertical'));
    }

    const nav = $('.ml-nav', header);
    function markOverflow() {
      if (!nav) return;
      const max = nav.scrollWidth - nav.clientWidth;
      if (max < 2) { delete nav.dataset.overflow; return; }
      nav.dataset.overflow = nav.scrollLeft < 2 ? 'start' : nav.scrollLeft > max - 2 ? 'end' : 'middle';
    }

    function position() {
      markOverflow();
      const top = Math.max(0, header.getBoundingClientRect().bottom);
      const root = document.documentElement.style;
      root.setProperty('--lhf-header-bottom', `${top}px`);
      root.setProperty('--site-header-height', `${header.offsetHeight}px`);
      root.setProperty('--m-header-height', `${header.offsetHeight}px`);
      if (window.MinimogSettings) window.MinimogSettings.headerHeight = header.offsetHeight;
      if (surface.hidden) return;
      header.style.setProperty('--ml-header-bottom', `${top}px`);
      backdrop.style.top = `${top}px`;
      if (mobile.matches) {
        surface.style.removeProperty('max-height');
        surface.style.removeProperty('top');
        return;
      }
      const panel = currentPanel();
      const layout = panel?.dataset.layout;
      const w = Math.min(Number(panel?.dataset.width) || 960, innerWidth - 48);
      let x = (innerWidth - w) / 2;
      const trigger = active && $(`[data-menu="${active}"]`, header);
      if (innerWidth < 1200 && ['compact', 'brands', 'about'].includes(layout) && trigger) {
        x = Math.max(24, Math.min(trigger.getBoundingClientRect().left - 18, innerWidth - w - 24));
      }
      surface.style.setProperty('--ml-width', `${w}px`);
      surface.style.setProperty('--ml-left', `${x}px`);
      surface.style.top = `${top + 10}px`;
      surface.style.maxHeight = `calc(100dvh - ${top + 30}px)`;
    }

    function stop() {
      sequence++;
      animation?.kill?.();
      animation?.cancel?.();
      animation = null;
      ['opacity', 'transform', 'visibility'].forEach((k) => surface.style.removeProperty(k));
    }

    function animate() {
      stop();
      const ticket = sequence;
      if (reduce.matches) return;
      const done = () => {
        if (ticket !== sequence) return;
        ['opacity', 'visibility', 'transform'].forEach((k) => surface.style.removeProperty(k));
      };
      if (window.gsap) {
        surface.dataset.motion = 'gsap';
        animation = window.gsap.timeline({ defaults: { ease: 'power2.out' }, onComplete: done });
        animation.fromTo(surface, { autoAlpha: 0, y: -7 }, { autoAlpha: 1, y: 0, duration: 0.22 }, 0);
      } else if (surface.animate) {
        surface.dataset.motion = 'browser-fallback';
        animation = surface.animate(
          [{ opacity: 0, transform: 'translateY(-7px)' }, { opacity: 1, transform: 'none' }],
          { duration: 220, easing: 'ease-out' }
        );
        animation.finished.then(done).catch(() => {});
      }
    }

    function sync() {
      const open = !surface.hidden;
      $$('[data-menu]', header).forEach((b) => b.setAttribute('aria-expanded', String(open && b.dataset.menu === active)));
      mobileButton?.setAttribute('aria-expanded', String(open));
      mobileButton?.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      header.classList.toggle('menu-open', open);
    }

    function open(id, trigger, focus = false) {
      if (id && !panels[id]) return;
      const wasOpen = !surface.hidden;
      if (!wasOpen || (trigger && !surface.contains(trigger))) opener = trigger || opener || mobileButton;
      active = id;
      if (!wasOpen) {
        oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      render();
      selectTab(0);
      surface.hidden = false;
      backdrop.hidden = false;
      document.querySelectorAll('main,footer').forEach((n) => {
        if (!n.hasAttribute('data-header-was-inert')) n.dataset.headerWasInert = String(n.inert);
        n.inert = true;
      });
      position();
      sync();
      animate();
      requestAnimationFrame(position);
      if (focus) $('a,button', currentPanel())?.focus({ preventScroll: true });
    }

    function close(restore = true) {
      if (surface.hidden) return;
      const t = opener;
      stop();
      surface.hidden = true;
      backdrop.hidden = true;
      document.querySelectorAll('[data-header-was-inert]').forEach((n) => {
        n.inert = n.dataset.headerWasInert === 'true';
        delete n.dataset.headerWasInert;
      });
      document.documentElement.style.overflow = oldOverflow;
      active = null;
      sync();
      if (restore && t?.isConnected && t.getClientRects().length) t.focus({ preventScroll: true });
    }

    header.addEventListener('click', (e) => {
      const b = e.target.closest('[data-menu],[data-root-menu]');
      if (b) {
        const id = b.dataset.menu || b.dataset.rootMenu;
        if (!surface.hidden && active === id && !b.dataset.rootMenu) close();
        else open(id, b, !!b.dataset.rootMenu);
        return;
      }
      if (e.target.closest('[data-mobile-menu]')) {
        if (!surface.hidden) close();
        else open(null, e.target.closest('button'), true);
        return;
      }
      if (e.target.closest('[data-menu-close]')) { close(); return; }
      if (e.target.closest('[data-menu-back]')) { open(null, opener, true); return; }
      const sub = e.target.closest('[data-sub]');
      if (sub) { selectTab(Number(sub.dataset.sub), true); return; }
      if (e.target.closest('.ml-search-entry,.m-cart-icon-bubble')) close(false);
    }, { signal });

    backdrop.addEventListener('click', () => close(), { signal });

    header.addEventListener('keydown', (e) => {
      const top = e.target.closest('[data-menu]');
      if (top && e.key === 'ArrowDown') { e.preventDefault(); open(top.dataset.menu, top, true); }
      const sub = e.target.closest('[data-sub]');
      if (sub && ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
        e.preventDefault();
        const count = tabs().length;
        const current = Number(sub.dataset.sub);
        const next = e.key === 'Home' ? 0 : e.key === 'End' ? count - 1
          : (current + (['ArrowUp', 'ArrowLeft'].includes(e.key) ? count - 1 : 1)) % count;
        selectTab(next, true);
      }
    }, { signal });

    document.addEventListener('keydown', (e) => {
      if (e.key === '/' && !e.ctrlKey && !e.metaKey && !e.altKey
        && !e.target.closest('input,textarea,select,[contenteditable=true]')
        && !document.querySelector('dialog[open]')) {
        e.preventDefault();
        close(false);
        $('.ml-search-entry', header)?.click();
        return;
      }
      if (surface.hidden || document.querySelector('dialog[open]')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        const elements = $$('a[href],button:not(:disabled)', header)
          .filter((el) => el.tabIndex >= 0 && el.getClientRects().length && !el.closest('[hidden]'));
        if (!elements.length) return;
        const first = elements[0];
        const last = elements.at(-1);
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }, { signal });

    // Compact bar: the full header scrolls away with the page; once it is fully out of view the same element is
    // fixed as a one-row bar (CSS .is-compact) and slides in. It slides out while the footer is in view.
    const wrapper = header.closest('.shopify-section') || header.parentElement;
    const compactOn = header.hasAttribute('data-compact-on-scroll');
    const footer = header.hasAttribute('data-compact-hide-footer')
      ? document.getElementById('lhf-footer') || document.querySelector('footer') : null;
    let compact = false;
    let atFooter = false;
    let frame = 0;

    // GSAP drives the bar when available (CSS transitions are the fallback); reduced motion and the editor stay instant.
    let gsap = null;
    let leaving = false;
    const calm = matchMedia('(prefers-reduced-motion: reduce)');

    function slide(visible) {
      if (!gsap) return;
      gsap.killTweensOf(header);
      if (visible) {
        gsap.set(header, { visibility: 'visible' });
        gsap.to(header, { yPercent: 0, duration: 0.45, ease: 'expo.out' });
      } else {
        gsap.to(header, {
          yPercent: -100, duration: 0.34, ease: 'power3.in',
          onComplete: () => gsap.set(header, { visibility: 'hidden' }),
        });
      }
    }

    function showCompact() {
      const visible = compact && !atFooter && !leaving;
      if (compact) {
        if (!visible && !surface.hidden) close(false);
        const state = visible ? 'shown' : 'hidden';
        const changed = header.dataset.compact !== state;
        header.dataset.compact = state;
        header.inert = !visible;
        if (changed) slide(visible);
      }
      document.documentElement.style.setProperty('--ls-header-offset', visible ? `${header.offsetHeight}px` : '0px');
    }

    function fitCompact() {
      if (!compact || mobile.matches || !nav) delete header.dataset.fit;
      else {
        for (const level of ['', 'tight', 'tighter']) {
          if (level) header.dataset.fit = level;
          else delete header.dataset.fit;
          if (nav.scrollWidth - nav.clientWidth < 2) break;
        }
      }
      markOverflow();
    }
    let fitFrame = 0;
    const queueFit = () => { if (!fitFrame) fitFrame = requestAnimationFrame(() => { fitFrame = 0; fitCompact(); }); };

    function setCompact(next) {
      if (next === compact) return;
      close(false);
      if (!next && gsap && header.dataset.compact === 'shown') {
        // Leaving: a static copy of the full header fills its place in the page, the bar slides away over it,
        // then the real header takes the copy's place (same look, so nothing moves).
        leaving = true;
        ghost?.remove();
        ghost = makeGhost();
        header.before(ghost);
        showCompact();
        gsap.killTweensOf(header);
        gsap.to(header, { yPercent: -100, duration: 0.32, ease: 'power2.inOut', onComplete: () => {
          leaving = false;
          ghost?.remove();
          ghost = null;
          unCompact(false);
        } });
        return;
      }
      compact = next;
      if (next) {
        wrapper.style.minHeight = `${wrapper.offsetHeight}px`;
        header.dataset.compact = 'hidden';
        if (gsap) {
          gsap.killTweensOf(header);
          gsap.set(header, { clearProps: 'opacity,visibility,transform' });
          gsap.set(header, { yPercent: -100, visibility: 'hidden' });
        }
        header.classList.add('is-compact');
        header.getBoundingClientRect();
      } else {
        unCompact(false);
        return;
      }
      fitCompact();
      showCompact();
      position();
    }

    let ghost = null;
    function makeGhost() {
      const copy = header.cloneNode(true);
      copy.querySelector('#menu-surface')?.remove();
      copy.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      copy.removeAttribute('id');
      copy.removeAttribute('style');
      copy.removeAttribute('data-compact');
      copy.removeAttribute('data-fit');
      copy.removeAttribute('data-site-header');
      copy.classList.remove('is-compact', 'ml-header--motion');
      copy.classList.add('ml-header--ghost');
      copy.inert = true;
      copy.setAttribute('aria-hidden', 'true');
      return copy;
    }

    function unCompact(animate) {
      compact = false;
      header.classList.remove('is-compact');
      delete header.dataset.compact;
      header.inert = false;
      wrapper.style.removeProperty('min-height');
      if (gsap) {
        gsap.killTweensOf(header);
        gsap.set(header, { clearProps: 'opacity,visibility,transform' });
        if (animate && wrapper.getBoundingClientRect().bottom > 0) {
          gsap.fromTo(header, { autoAlpha: 0, y: -14 }, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'power3.out', clearProps: 'opacity,visibility,transform' });
        }
      }
      fitCompact();
      showCompact();
      position();
    }

    function updateCompact() {
      frame = 0;
      const bottom = wrapper.getBoundingClientRect().bottom;
      if (leaving) {
        if (bottom <= 0) { leaving = false; ghost?.remove(); ghost = null; showCompact(); slide(true); }
        return;
      }
      if (!compact && bottom <= 0) setCompact(true);
      else if (compact && bottom >= header.offsetHeight) setCompact(false);
    }
    const queueCompact = () => { if (!frame) frame = requestAnimationFrame(updateCompact); };

    let footerObserver = null;
    if (compactOn) {
      window.addEventListener('scroll', queueCompact, { passive: true, signal });
      window.addEventListener('resize', queueCompact, { signal });
      window.addEventListener('resize', queueFit, { signal });
      document.fonts?.ready.then(() => { if (!signal.aborted) queueFit(); });
      if (footer) {
        footerObserver = new IntersectionObserver(([entry]) => { atFooter = entry.isIntersecting; showCompact(); });
        footerObserver.observe(footer);
      }
      updateCompact();
      const useGsap = () => {
        if (signal.aborted || calm.matches || window.Shopify?.designMode || !window.lsLoadGsap) return;
        window.lsLoadGsap(header.dataset.gsapSrc).then((g) => {
          if (signal.aborted || calm.matches) return;
          gsap = g;
          header.classList.add('ml-header--motion');
          if (compact) gsap.set(header, header.dataset.compact === 'shown' ? { yPercent: 0, visibility: 'visible' } : { yPercent: -100, visibility: 'hidden' });
        }).catch(() => {});
      };
      if ('requestIdleCallback' in window) requestIdleCallback(useGsap, { timeout: 2000 });
      else setTimeout(useGsap, 800);
    }

    window.addEventListener('resize', position, { signal });
    window.addEventListener('scroll', position, { passive: true, signal });
    $('.ml-nav', header)?.addEventListener('scroll', position, { passive: true, signal });
    const onMobileChange = () => close(false);
    mobile.addEventListener('change', onMobileChange);
    window.addEventListener('linsoul:overlay-opening', () => close(false), { signal });

    const unsubscribe = window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.openCartDrawer
      ? window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, () => close(false))
      : null;

    const observer = new ResizeObserver(position);
    observer.observe(header);

    document.addEventListener('shopify:block:select', (e) => {
      const panel = panels[e.detail?.blockId];
      if (panel) open(e.detail.blockId, $(`[data-menu="${e.detail.blockId}"]`, header));
    }, { signal });
    document.addEventListener('shopify:block:deselect', () => close(false), { signal });

    window.LinsoulHeader = {
      open: (id) => open(id, $(`[data-menu="${id}"]`, header)),
      close: () => close(true),
      getState: () => ({ active, open: !surface.hidden }),
    };
    window.LinsoulUI = {
      closeTransient: () => close(false),
      openSearch: () => $('.ml-search-entry', header)?.click(),
      openMenu: (id) => open(id, $(`[data-menu="${id}"]`, header)),
      closeMenu: () => close(),
    };

    sync();
    position();

    teardown = () => {
      close(false);
      controller.abort();
      cancelAnimationFrame(frame);
      cancelAnimationFrame(fitFrame);
      footerObserver?.disconnect();
      setCompact(false);
      document.documentElement.style.removeProperty('--ls-header-offset');
      mobile.removeEventListener('change', onMobileChange);
      observer.disconnect();
      if (typeof unsubscribe === 'function') unsubscribe();
      teardown = null;
    };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#menu-header')) init();
  });
  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.querySelector('#menu-header')) teardown?.();
  });
})();
